<template>
    <div>

        <!-- Go back to draft card -->

        <trax-ui-card :title="lang.polaris.procedure.back_to_draft" title-bold="1" v-show="visible && launchPermission && atpDafEditStatus">

            {{ lang.polaris.procedure.back_to_draft_text }}

            <div class="mt-3 text-right">
                <button class="btn btn-round btn-default" @click="backToDraft">
                    {{ lang.polaris.procedure.back_to_draft }}
                </button>    
            </div>

        </trax-ui-card>

        <!-- Go back to draft confirm modal -->

        <trax-ui-modal-confirm :id="id+'-reset-modal'" :title="lang.polaris.procedure.back_to_draft" :bus="bus">
            {{ lang.polaris.procedure.confirm_back_to_draft_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-reset-toastr'" passed-label="1" :bus="bus">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            visibleWhen: null,
            hiddenWhen: null,
            atp: null,
        },

        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                user: user,
                endpoint: app_url+'polaris/api/front/procedures/'+data.procedure.id+'/reset',
                registration: data.registration,
                phase: data.phase,
                learner: data.learner,
                visible: false,
                bus: this.$bus
            }
        },

        computed: {

            launchPermission: function() {
                if (this.user.admin) return true;
                if (this.atp && this.user.permissions['procedure.write-atp']) return true;
                if (!this.atp && this.user.permissions['procedure.write-daf']) return true;
                var userFunction = this.user.user_function;
                if (!userFunction) return false;
                return userFunction == 'training' || userFunction == 'training_op';
            },

            atpDafEditStatus: function() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            },
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
            this.bus.$on(this.id+'-reset-modal-confirmed', this.backToDraftConfirmed);
        },

        methods:  {

            setData(procedure) {
                this.visible = procedure.data[this.visibleWhen] 
                    && !procedure.data[this.hiddenWhen]
            },

            backToDraft() {
                this.bus.$emit(this.id+'-reset-modal-open');
            },

            backToDraftConfirmed() {
                axios.post(this.endpoint)
                    .then(response => {
                        window.location.reload();
                    })
                    .catch(error => {
                        this.bus.$emit(this.id+'-reset-toastr-error', error.response.data);
                    });
            },
        }
    }
</script>
